import React from "react";
import { observer } from "mobx-react";
import { Button } from "@mui/material";
import { CloseIcon as CancelIcon } from "../../../icons";
import { useRootStore } from "../../../store/contexts";

type CloseFormProps = {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
};

export const CloseFormButton: React.FC<CloseFormProps> = observer(
  ({ onClick, disabled, label }) => {
    const rootStore = useRootStore();
    const { prefStore, langStore } = rootStore;

    return (
      <Button
        sx={{ color: "text.primary" }}
        variant={"action"}
        size={prefStore.toolbarSize}
        startIcon={<CancelIcon />}
        disabled={disabled === undefined ? false : disabled}
        onClick={onClick}
      >
        {!label ? langStore.closeForm : label}
      </Button>
    );
  }
);
